import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { environment } from "environments/environment";

declare const gtag: Function;

@Injectable({
  providedIn: "root",
})
export class GoogleAnalyticsService {
  constructor(
    private readonly router: Router,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  public initialize() {
    if (!environment.googleAnalyticsId) {
      return; // no GA configured
    }

    this.onRouteChange();

    try {
      const url = "https://www.googletagmanager.com/gtag/js?id=";
      const gTagScript = this.document.createElement("script");
      gTagScript.async = true;
      gTagScript.src = `${url}${environment.googleAnalyticsId}`;
      this.document.head.appendChild(gTagScript);

      const dataLayerScript = this.document.createElement("script");
      dataLayerScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${environment.googleAnalyticsId}', {'send_page_view': false});
    `;
      this.document.head.appendChild(dataLayerScript);
    } catch {
      // fail silently
    }
  }

  // track visited routes
  private onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        gtag("config", environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects,
        });
      }
    });
  }

  // use gtag.js to send Google Analytics Events
  public event(
    action: string,
    eventCategory?: string,
    eventLabel?: string,
    value?: string,
  ) {
    gtag("event", action, {
      ...(eventCategory && { event_category: eventCategory }),
      ...(eventLabel && { event_label: eventLabel }),
      ...(value && { value: value }),
    });
  }
}
